import { RedirectToRoute } from 'aurelia-router';

import { Notification } from '~/components/notification/notification';
import { FetchUtils } from '~/utils/fetch-utils';
import { Logger } from '~/utils/logger';
import { ErrorPageParams } from '~/views/error-page/error-page';

/**
 * For use with page activate() methods so that errors can be handled gracefully.
 * See classic-form.ts.
 */
export function pageErrorHandler(error: any): Promise<never> {
	const errorMessage = FetchUtils.normalizeError(error);
	FetchUtils.logAndDisplayError(errorMessage);

	// Redirect to error page
	const params: ErrorPageParams = {
		errorMessage,
	};
	return Promise.reject(new RedirectToRoute('error', params));
}
